<template>
    <slot
        v-bind="{
            purchasableId,
            addToCartLoading,
            amount,
            quantity,
            isInCart,
            addToCart
        }"
    ></slot>
</template>

<script>
export default {
    props: {
        purchasableId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            addToCartLoading: false,
            amount: 20,
            quantity: 1,
            isInCart: false,
        };
    },

    methods: {
        async addToCart() {
            if (this.isInCart) {
                location.href = '/shop/checkout';
                return;
            }

            this.addToCartLoading = true;

            const options = {
                amount: this.amount,
            };

            await this.$store.dispatch('cart/addToCart', {
                id: this.purchasableId,
                options,
            });

            this.isInCart = true;
            this.addToCartLoading = false;
        },
    },
};
</script>
